<mat-sidenav-container class="mainWrapper blue_theme light-theme background-image" [class.sidebarNav-mini]="isCollapsedWidthFixed" autosize autoFocus dir="ltr">
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->

  <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="!isOver"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    <div class="flex-layout">
      <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(item of navItems; track item) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()">
          </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
      <!-- <div class="p-16 m-t-16" *ngIf="isUserStore()">

        <mat-form-field appearance="fill" class="full-width camouflaged-select" style="width: 100%;">
          <mat-label>Negocio Seleccionado</mat-label>
          <mat-select [(value)]="selectedStore" (selectionChange)="onOptionChange($event)">
            <mat-option *ngFor="let store of stores" [value]="store">
              {{ store.nombre }}
            </mat-option>
          </mat-select>
        </mat-form-field>        

      </div> -->
    </div>
  </mat-sidenav>


  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper p-l-24 p-r-24" #content>

    <main class="pageWrapper maxWidth">
      <!-- ============================================================== -->
      <!-- VerticalHeader -->
      <!-- ============================================================== -->

      <ng-container>
        <app-header [showToggle]="true" (toggleCollapsed)="toggleCollapsed()"
          (toggleMobileNav)="sidenav.toggle()" (toggleWebNav)="toggleCollapsed()"></app-header>
      </ng-container>


      <div class="m-t-30">

        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>
      </div>

    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
